Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-review-form', function (envelope) {

        var $context = envelope.message.data.context,
            $form = $('.x-product-review-form', $context);

        if ($form.length < 1) return;

        var form = $form.get(0);
        var config = {};

        //generic functions in form.js
        hookFormsFn($form);
        hookAjaxFormsFn($form);

        var onSuccessFn = form.onSuccess;

        form.onSuccess = function (request, response) {
            onSuccessFn(request, response);
        };

        form.submit = function (configuration) {
            config = configuration;

            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents(config);
            } else {
                form.submitReview(config);
            }
        };

        form.submitReview = function () {
            if (form.isLoading())
                return;

            form.showLoader();

            var state = Vendd.Product.Controller.getState();
            var id = state.parentId;

            Vendd.MessageBus.publishAsync(form, new Vendd.Product.Messages.Review(config.title, config.description, config.rating, id));
        };

        form.checkConsents = function (config) {
            var data = [];

            var checkboxes = $('.form-row.consent.checkbox', $form);
            $.each(checkboxes, function (e, el) {
                var chkbx = $('.checkbox-wrapper input', el);
                data.push({ type: chkbx.attr('id'), source: 'Review Form', approved: chkbx.prop("checked") });
            });

            if (data.length > 0) {
                window.ConsentsManager.insertConsents(data);
            } else {
                form.submitReview(config);
            }
        };

        function successFn(envelope) {
            form.hideLoader();

            var responseData = envelope.message.data;

            if (responseData.Success) responseData.success = responseData.Success;
            if (responseData.Code) responseData.code = responseData.Code;
            if (responseData.data) responseData.data = responseData.Data;
            if (responseData.time) responseData.time = responseData.Time;

            if (!responseData.success && responseData.code == 'GenericError') {
                if (typeof (responseData.Data) == 'string') {
                    try {
                        responseData.Data = jQuery.parseJSON(responseData.Data);
                    } catch (e) {

                    }
                };
            };

            if (responseData.success && typeof (form.onSuccess) === 'function') {
                form.onSuccess(envelope.message.config, responseData);
            } else {
                if (!responseData.success && typeof (form.onFailure) === 'function') {
                    form.onFailure(envelope.message.config, responseData);
                };
            };
        };

        function failureFn(ex) {
            form.hideLoader();

            var response = {
                code: 'GenericError',
                success: false,
                time: 0
            };

            if (ex.responseText) {
                response.data = jQuery.parseJSON(ex.responseText)
            } else {
                response.data = ex;
            }

            if (typeof (form.onFailure) === 'function') {
                form.onFailure(config, response);
            }
        };

        if ($(".view-terms", $form).length > 0) {
            $(".view-terms", $form).fancybox({
                touch: false,
                autoFocus: false
            });
        }

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewSuccess, form, successFn);

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewFailure, form, failureFn);

        Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submitReview);

    });

});

